import React, { FC } from 'react';
import GetMyPlanBlock from '../../../../components/getMyPlanBlock';
import RealPhoto from '../../../../components/realPhoto';
import SafetyAssurance from '../../../../../../UI/common/safetyAssurance';
import Description from '../../../../components/withTimerDesign/description';
import Featured from '../../../../components/withTimerDesign/featured';
import Reviews from '../../../../components/withTimerDesign/reviews';
import { GENDER } from '../../../../../activationInstructions/components/paymentSuccessfulV1/params';
import { Alert, Course, Subtitle, Title, Coaching } from './components';
import beforeMale from './img/beforeMale.png';
import before from './img/before.png';
import afterMale from './img/afterMale.png';
import after from './img/after.png';
import * as S from './styled';
import { appStore } from '@store';

interface Props {
	children: React.ReactElement;
	gender?: GENDER;
}

export const PaywallLayoutAcademy: FC<Props> = props => {
	const { gender = GENDER.FEMALE, children } = props;
	const { safetyAssurance } = appStore.paymentStore.settings;
	const { academyPlanVersion } = appStore.abTestsStore.params;

	return (
		<S.Container>
			<Title />
			<S.VerticalPadding20>
				<Subtitle />
			</S.VerticalPadding20>
			<RealPhoto
				maleBeforeImg={beforeMale}
				maleAfterImg={afterMale}
				femaleBeforeImg={before}
				femaleAfterImg={after}
				maleWeightBefore='203 lbs'
				maleWeightAfter='149 lbs'
				femaleWeightAfter='149 lbs'
				femaleWeightBefore='203 lbs'
				onlyImages
			/>
			{academyPlanVersion === 'V3' ? (
				<>
					<S.Padding20 />
					<Coaching />
				</>
			) : null}
			<S.Padding20 />
			<S.Padding20 />
			<Course />
			<S.VerticalPadding20>
				<Alert />
			</S.VerticalPadding20>
			{children}
			{safetyAssurance && <SafetyAssurance />}
			<GetMyPlanBlock />
			<Reviews />
			<Featured />
			<Description />
		</S.Container>
	);
};
